<template>
	<section id="intro" class="main-content intro">
		<div class="row">
			<slot name="content">
				<div class="columns column6">
					<h4 v-if="subtitle" class="subtitle">
						<span>{{ subtitle }}</span>
						<div class="subtitle-line" />
					</h4>
					<h1>{{ title }}</h1>
				</div>
			</slot>
			<slot name="rightcontent">
				<div class="columns column6">
					<div v-parse-links v-html="content" />
					<p v-if="roomtypeid">
						<book-button :roomtypeid="parseInt(roomtypeid, 10)" class="button button-cta">
							{{ $t('bookThisRoom') }}
						</book-button>
					</p>
				</div>
			</slot>
			<slot />
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
	roomtypeid: { type: Number, default: 0 },
	rateid: { type: String, default: '' },
});
</script>
